@let hasAbsenceCreatePermission =
  can(RoleAction.Create, RolePermissionSubject.Absence);

<div class="d-flex">
  @if (
    {
      isDraggable:
        createNewViaDragAndDropService.isNewAbsenceQuickActionCardDraggable$
        | async,
    };
    as data
  ) {
    <div
      class="absence-card d-flex"
      nz-tooltip
      [nzTooltipTitle]="
        !hasAbsenceCreatePermission
          ? ('general.forbidden_action' | translate)
          : null
      "
      [class.hide-card]="!isQuickCreationCardOpen"
      [class.not-allowed]="!hasAbsenceCreatePermission || !data.isDraggable"
      [draggable]="hasAbsenceCreatePermission && data.isDraggable"
      (dragstart)="startDrag($event)"
      (dragend)="dragEnd()"
      data-test-id="wilson-new-absence-quick-action-card"
    >
      <span class="fw-normal text-dark card-text">
        {{ 'enum.absence_category.rest-day' | translate }}
      </span>
    </div>
  }
</div>
